import { Box, Button, Container, Grid, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { withNamespaces } from "react-i18next";
import { InvoicePayNowList, PaymentButton } from "../../components";
import { FontFamilySwitch, getTotalReduce } from "../../utils";
import InvoicePay from "./invoicePay";
const useStyles = makeStyles((theme) => ({
  root: {},
  title: {
    fontSize: "1rem",
    fontFamily: FontFamilySwitch().bold,
    color: theme.typography.color.primary,
  },
  totalAmount: {
    fontSize: "0.875rem",
    fontFamily: FontFamilySwitch().bold,
    color: theme.typography.color.primary,
  },
  subTitle: {
    fontSize: "0.75rem",
    fontFamily: FontFamilySwitch().semiBold,
    color: theme.typography.color.secondary,
    margin: "10px 0 8px 0",
  },
  drawer: {
    "& .MuiDrawer-paper": {
      borderTopLeftRadius: "4px",
      borderTopRightRadius: "4px",
    },
  },
  dialog: {
    "& .MuiDialog-paper": {
      borderRadius: "4px",
      padding: "0px",
    },
  },
  btn: {
    padding: "10px",
    borderRadius: theme.palette.borderRadius,
    boxShadow: "none",
    border: "1px solid #5078e1",
    backgroundColor: "#5078e1",
    color: "#fff",
    "&:hover": {
      boxShadow: "none",
      backgroundColor: "#5078e1",
      opacity: "0.9"
    },
  },
  btn1: {
    padding: "10px",
    borderRadius: theme.palette.borderRadius,
    backgroundColor: "#fff",
    border: "1px solid #5078e1",
    color: "#5078e1",
    boxShadow: "none",
    textTransform: "capitalize",
    "&:hover": {
      boxShadow: "none",
      backgroundColor: "#fff",
      opacity: ".8",
    },
  },
}));

const InvoicePaymentScreen = (props) => {
  const classes = useStyles();
  const [paymentoption, setPaymentoption] = React.useState(false);
  const [formopen, setformopen] = React.useState(false);
  let activeInvoices = props?.data?.filter((x) => x?.active)
  return (
    <div className={classes.root}>
      <Container maxWidth="sm" sx={{ padding: "0px" }}>
        <Grid Container>
          {props?.data?.map((val) => {
            return (
              <>
                {val.active === true && (
                  <Grid xs={12}>
                    <InvoicePayNowList
                      InvoicePay={val}
                      onDelete={() => props.onDelete(val, false)}
                      viewinvoice={props.viewinvoice}
                    />
                  </Grid>
                )}
              </>
            );
          })}
          <Grid item xs={12}>
            <Grid
              container
              justifyContent={"center"}
              alignItems={"center"}
              spacing={0}
            >
              {/* <Grid item xs={12} sx={{ marginTop: "8px" }}>
                <Typography
                  className={classes.title}
                  sx={{ marginBottom: "5px" }}
                >
                  {props?.t("bill_summary")}
                </Typography>
              </Grid> */}
              {/* <Grid item xs={12} style={{ display: "flex", marginTop: "-8px" }}>
                <Grid item xs={6}>
                  <Typography className={classes.subTitle}>
                    {props?.t("invoice_amount")}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <div style={{ float: "right" }}>
                    <Typography className={classes.subTitle}>
                      {props?.data?.[0]?.currency_master?.symbol + (" ") +
                        Intl.NumberFormat("en-IN", {
                          minimumFractionDigits: 0,
                        }).format(Math.round(getTotalReduce(props?.data?.filter((x)=>x?.active) , "invoice_due_amount")))}
                    </Typography>
                  </div>
                </Grid>
              </Grid> */}

              {/* <Box height={"10px"} /> */}
              <Grid
                item
                xs={12}
                style={{
                  display: "flex",
                  padding: "12px 0",
                  borderBottom: "2px dashed #CED3DD",
                  borderTop: "2px dashed #CED3DD",
                }}
              >
                <Grid item xs={6}>
                  <Typography className={classes.totalAmount}>
                    {props?.t("total_amount_to_pay")}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <div style={{ float: "right" }}>
                    <Typography className={classes.totalAmount}>
                    {props?.data?.[0]?.currency_master?.symbol + (" ") +
                        Intl.NumberFormat("en-IN", {
                          minimumFractionDigits: 0,
                        }).format(Math.round(getTotalReduce(props?.data?.filter((x) => x?.active), "invoice_due_amount")))}
                    </Typography>
                  </div>
                </Grid>
              </Grid>
              <Box margin={"10px"} />
              <Grid item container xs={12} spacing={2}>
                <Grid item xs={6}>
                  <Button
                    variant="contained"
                    className={classes.btn1}
                    onClick={() => setformopen(true)}
                    fullWidth
                    disabled={props?.activeinvoice <= 1 ? false : true}
                  >
                    {props?.t("already_paid")}
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <PaymentButton
                    company_id={props?.data?.[0]?.company_id}
                    invoice_total={activeInvoices?.reduce((prevAmonut, currentAmount) => prevAmonut + currentAmount?.invoice_due_amount, 0) ?? 0}
                    invoices={activeInvoices}
                    currency={activeInvoices?.[0]?.currency_master?.symbol}
                    currency_id={activeInvoices?.[0]?.currency_id}
                    currency_code={activeInvoices?.[0]?.currency_master?.code}
                    account_no={activeInvoices?.[0]?.account_no}
                    contact={activeInvoices?.[0]?.contact}
                    onClose={props?.onClose}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Box height="12px" />
          </Grid>
        </Grid>
      </Container>
      <InvoicePay
        paymentoption={paymentoption}
        onClose={() => setPaymentoption(false)}
        formopen={formopen}
        onClose1={() => setformopen(false)}
        Outstanding_amount={props?.total}
        amount={props?.total}
        currency_symbol={props?.data?.[0]?.currency_master?.symbol}
        currency_id={props?.data?.[0]?.currency_id}
        company_id={props?.data?.[0]?.company_id}
        invoices={props?.data
          ?.filter((val) => val.active === true)
          .map((item) => item?.id)}
      />
    </div>
  );
};
export default withNamespaces("invoice")(InvoicePaymentScreen);
